export default __webpack_public_path__ + "static/media/Take me back to.b1c512ec.mp4";